import { NAVY, MUTED, ORANGE, PrimaryButton, displayFont } from "../FlightFinalOffer/ui";

// Full-card states for the pay-later page (errors, confirming, timeouts),
// in the same glass-card language as the flight checkout.

const TONES = {
  error: { bg: "rgba(239,68,68,.1)", color: "#DC2626" },
  warning: { bg: "rgba(245,158,11,.12)", color: "#D97706" },
  progress: { bg: "rgba(255,106,26,.1)", color: ORANGE },
};

const ToneIcon = ({ tone }: { tone: keyof typeof TONES }) => {
  const { color } = TONES[tone];
  if (tone === "progress") {
    return (
      <svg width="28" height="28" viewBox="0 0 24 24" style={{ animation: "co-spin .8s linear infinite" }}>
        <circle cx="12" cy="12" r="10" stroke="rgba(255,106,26,.25)" strokeWidth="3" fill="none" />
        <path d="M12 2a10 10 0 0110 10" stroke={color} strokeWidth="3" strokeLinecap="round" fill="none" />
      </svg>
    );
  }
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="7" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
};

export const PayLaterMessage = ({
  tone,
  title,
  body,
  actionLabel,
  onAction,
}: {
  tone: keyof typeof TONES;
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
}) => (
  <div className="max-w-[520px] mx-auto">
    <div className="co-card p-8 text-center">
      <div
        className="mx-auto mb-5 flex items-center justify-center"
        style={{
          width: 64,
          height: 64,
          borderRadius: 999,
          background: TONES[tone].bg,
          animation: "co-pop-in .45s cubic-bezier(.34,1.56,.64,1) both",
        }}
      >
        <ToneIcon tone={tone} />
      </div>
      <h2 style={{ fontFamily: displayFont, fontSize: 22, fontWeight: 700, color: NAVY, marginBottom: 8 }}>
        {title}
      </h2>
      <p style={{ color: MUTED, fontSize: 15, lineHeight: 1.6, marginBottom: actionLabel ? 24 : 0 }}>{body}</p>
      {actionLabel && onAction && <PrimaryButton onClick={onAction}>{actionLabel}</PrimaryButton>}
    </div>
  </div>
);

const Bar = ({ h, w = "100%" }: { h: number; w?: string }) => (
  <div
    style={{
      height: h,
      width: w,
      borderRadius: 12,
      background: "linear-gradient(90deg,#e8e2d8 25%,#f0ebe2 50%,#e8e2d8 75%)",
      backgroundSize: "200% 100%",
      animation: "pl-shimmer 1.3s infinite",
    }}
  />
);

export const PayLaterSkeleton = () => (
  <div className="max-w-[640px] mx-auto space-y-4">
    <style>{`@keyframes pl-shimmer { to { background-position: -200% 0; } }`}</style>
    <div className="co-card p-6 space-y-3">
      <Bar h={14} w="30%" />
      <Bar h={24} w="70%" />
      <div className="grid grid-cols-2 gap-3 pt-2">
        <Bar h={56} />
        <Bar h={56} />
      </div>
    </div>
    <div className="co-card p-6 space-y-3">
      <Bar h={14} w="30%" />
      <Bar h={18} />
      <Bar h={18} />
      <Bar h={18} />
    </div>
    <Bar h={52} />
  </div>
);
